import React from 'react'
import ScanCode from "../../../components/ScanCode/ScanCode"
import OrderItemDetail from "./OrderItemDetail"
import ableToPrint from "../../../components/AbleToPrint/ableToPrint"
import {withRouter} from "react-router-dom"


class PrintQRPage extends React.Component {
    state = {
        input: '',
        current: {
            number: null,
            index: null,
            code: '',
        },
        time: null
    }

    _handleSubmit = async order => {
        const {current} = this.state

        const data = {
            ...current,
            ...order
        }

        const {code} = data
        const able = await ableToPrint(code, 'print_qr', this._handleOnReset)
        if (!able) return false

        this.setState({
            current: data,
            time: Date.now()
        })
    }

    _handleChangeInput = value => {
        this.setState({
            input: value,
        })
    }

    _handlePrintComplete = () => {
        this.setState({input: ''})
    }

    _handleOnReset = () => {
        this.setState({
            input: '',
            current: {
                number: null,
                index: null,
                code: '',
            }
        })
    }

    render() {
        const {input, current, time} = this.state

        return (
            <div className='PrintPage'>
                <ScanCode value={input} onChange={this._handleChangeInput} onReset={this._handleOnReset}
                          onSubmit={this._handleSubmit}/>
                <OrderItemDetail time={time} onComplete={this._handlePrintComplete} barcode={current}/>
            </div>
        )
    }
}

export default withRouter(PrintQRPage)
